var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.25C1 2.00736 1.92177 1 3.05882 1H12.9412C14.0782 1 15 2.00736 15 3.25V16.75C15 17.9926 14.0782 19 12.9412 19H3.05882C1.92177 19 1 17.9926 1 16.75V3.25Z",
    fill: "#0083FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64706 13.6C2.64706 13.3515 2.86493 13.15 3.13369 13.15H7.51337C7.78213 13.15 8 13.3515 8 13.6C8 13.8485 7.78213 14.05 7.51337 14.05H3.13369C2.86493 14.05 2.64706 13.8485 2.64706 13.6Z",
    fill: "#EEF6FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64706 15.85C2.64706 15.6015 2.86493 15.4 3.13369 15.4H7.51337C7.78213 15.4 8 15.6015 8 15.85C8 16.0985 7.78213 16.3 7.51337 16.3H3.13369C2.86493 16.3 2.64706 16.0985 2.64706 15.85Z",
    fill: "#EEF6FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64706 11.35C2.64706 11.1015 2.83141 10.9 3.05882 10.9H12.9412C13.1686 10.9 13.3529 11.1015 13.3529 11.35C13.3529 11.5985 13.1686 11.8 12.9412 11.8H3.05882C2.83141 11.8 2.64706 11.5985 2.64706 11.35Z",
    fill: "#EEF6FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6C13 7.65685 11.6569 9 10 9C8.34315 9 7 7.65685 7 6C7 4.34315 8.34315 3 10 3C11.6569 3 13 4.34315 13 6Z",
    fill: "#EEF6FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6424 4.68221C11.8179 4.81629 11.8516 5.06731 11.7175 5.24288L9.91528 7.60295L8.71933 6.42836C8.56172 6.27356 8.55943 6.0203 8.71423 5.86269C8.86903 5.70508 9.12228 5.7028 9.27989 5.8576L9.82939 6.39728L11.0817 4.75735C11.2158 4.58178 11.4668 4.54814 11.6424 4.68221Z",
    fill: "#0083FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17.7871V7.46008C17 7.20599 17.2239 7 17.5 7H18.5C18.7761 7 19 7.20599 19 7.46008V17.7871C19 17.8717 18.9746 17.9547 18.9266 18.027L18.4266 18.7798C18.2317 19.0734 17.7683 19.0734 17.5734 18.7798L17.0734 18.027C17.0254 17.9547 17 17.8717 17 17.7871Z",
    fill: "#0083FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.12552f37.svg";
export { ForwardRef as ReactComponent };